<template>
  <div class="card-deck">
    <div class="card">

      <div class="card-header">Map</div>

      <div class="card-body">
        <l-map
            ref="map"
            @ready="onMapReady"
            class="app-map"
            :zoom="zoom"
            :center="center"
        >
<!--
        <l-tile-layer
            :url="url"
            :attribution="attribution"
            :options="tileLayerOptions"
        />
-->
<l-control-layers position="topright"></l-control-layers>
<l-tile-layer
      v-for="tileProvider in tileProviders"
      :key="tileProvider.name"
      :name="tileProvider.name"
      :visible="tileProvider.visible"
      :url="tileProvider.url"
      :attribution="tileProvider.attribution"
      layer-type="base"/>

    <v-marker-cluster :options="clusterOptions" @clusterclick="click()" class="bruno">

        <LGeoJson
        v-if="geojson2Ready"
        :geojson="geojson2"
        :options="geojson2Options"
        :options-style="styleFunction"
      />
    </v-marker-cluster>


        </l-map>
      </div>
    </div>
  </div>
</template>

<script>
import { latLng } from 'leaflet'
//import { LMap, LTileLayer } from 'vue2-leaflet'
import * as Vue2Leaflet from 'vue2-leaflet'
import msgMixin from '../mixins/msg-mixin'
import '@geoman-io/leaflet-geoman-free'
import 'leaflet/dist/leaflet.css'
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'
import * as turf from 'turf';

export default {
  name: 'AppMap',
  components: {
    //LMap,
    //LTileLayer
      'LMap': Vue2Leaflet.LMap,
      'LTileLayer': Vue2Leaflet.LTileLayer,
      'LGeoJson': Vue2Leaflet.LGeoJson,
      'v-marker-cluster': Vue2LeafletMarkercluster,
      'LControlLayers': Vue2Leaflet.LControlLayers,
/*
    'v-map': Vue2Leaflet.LMap,
    'v-tilelayer': Vue2Leaflet.LTileLayer,
    'v-geo-json': Vue2Leaflet.LGeoJson,
*/
  },
  mixins: [msgMixin],
  data() {
    return {
            geojson2Ready: false,
            geojson2: null,
            geojson2FillColor: '#e4ce7f',
            geojson2Area : 0,
            clusterOptions: {},
            zoom: 17,
            tileLayerOptions:{ maxNativeZoom: 18, maxZoom: 22 },
            center: latLng(44.323779 , -0.250099/*45.598803, 0.528267*/),
            tileProviders: [
                {
                  name: 'Carte',
                  visible: true,
                  attribution:
                    '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                },
                {
                  name: 'Satellite',
                  visible: false,
                  url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                  attribution:
                    'Tiles © Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
                }
            ],
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            editPolygonsObj : {editOn:false, isPolygonCreated:false, isPolygonModified:false, polygons:[]}
        }
  },
  methods: {
    onMapReady() {
        this.map = this.$refs.map.mapObject

        this.map.pm.addControls({
            position: 'topleft',
            drawCircle: false,
            drawCircleMarker: false,
            drawMarker: false,
            drawPolyline: false,
            drawRectangle: false
          })

        const editPolygonsObj = this.editPolygonsObj;
        this.map.on('pm:create', function(e) {
            editPolygonsObj.isPolygonCreated = true;
            console.log(e);
        // this.successMsg(`Created ${shape} with ${layer._latlngs}`)
      })

/*
        this.map.on('pm:action', ({shape, layer}) => {
            this.successMsg(`Created ${shape} with ${layer._latlngs}`)
      })
*/

        this.map.on('pm:globaleditmodetoggled', function(e) {
            if (editPolygonsObj.editOn) {
                if (editPolygonsObj.isPolygonModified) {
                    alert('surface originelle : ' + turf.area(editPolygonsObj.polygon) + 'm², modifiée : ' + turf.area(editPolygonsObj.polygonModified) + 'm²')
                }
                else {
                    alert('surface originelle : ' + turf.area(editPolygonsObj.polygon) + 'm²')
                }
            }
            editPolygonsObj.editOn = !editPolygonsObj.editOn;
            console.log(e);
        });

    }
  },
  computed: {
    geojson2Options() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    styleFunction() {
      const fillColor = this.geojson2FillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 2,
          color: '#ECEFF1',
          opacity: 0.8,
          fillColor: fillColor,
          fillOpacity: 0.6
        };
      };
    },
    onEachFeatureFunction() {
        var thisObj = this
      return (feature, layer) => {

        if (layer.feature.geometry.type === 'MultiPolygon') {
            var polygon = turf.multiPolygon(layer.feature.geometry.coordinates)
            thisObj.editPolygonsObj.polygon = polygon;
            layer.on('pm:edit',  ({layer}) => {
                thisObj.editPolygonsObj.isPolygonModified = true;
                thisObj.editPolygonsObj.polygonModified = layer.toGeoJSON();
                //alert('surface originelle : ' + turf.area(thisObj.editPolygonsObj.polygon) + 'm², modifiée : ' + turf.area(thisObj.editPolygonsObj.polygonModified) + 'm²')
                //console.log(e);
            });
            thisObj.geojson2Area += turf.area(polygon)
            thisObj.editPolygonsObj.polygons.push(polygon)
        }
      if (!this.enableTooltip) {
        return () => {};
      }
        layer.bindTooltip(
          '<div>code:' +
            feature.properties.code +
            '</div><div>nom: ' +
            feature.properties.nom +
            '</div>',
          { permanent: false, sticky: true }
        );
      };
    }
  },
  async created() {
    this.loading = true;
    //const response = await fetch('https://apicarto.ign.fr/api/cadastre/parcelle?code_insee=24565&section=0D&numero=0044&_limit=20');
    const response = await fetch('https://apicarto.ign.fr/api/cadastre/parcelle?code_insee=33095&section=0A&numero=0514&_limit=20');
    const data = await response.json();
    this.geojson2 = data;
    this.geojson2Ready = true,
    this.loading = false;
  },
    mounted() {
/*
      setTimeout(() => {
        console.log('done')
        this.$nextTick(() =>{
          this.clusterOptions = { disableClusteringAtZoom: 11 }
        });
      }, 5000);
*/
    }
}
</script>

<!-- <style lang="scss" scoped> -->
<style scoped>
.app-map {
    height: 800px;
    }
    /*
div.leaflet-pm-draw {
    display:none;
    }
    */
</style>
